// extracted by mini-css-extract-plugin
export default {"icon":"ED9J2ru9fA"};